import * as React from "react";
const SvgIconChevronLeft = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "silver", d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6 1.41-1.41z" }));
export default SvgIconChevronLeft;
